import React, { FC } from 'react';
import { MtsFormGroup, MtsLabel } from '@mts-ds/components-react';
import Grid from '@material-ui/core/Grid';
import Tooltip from '../../../Tooltip';
import Icon from '../../../Icon';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    verticalAlign: 'middle'
  },
  group: {
    position: 'relative'
  },
  wrapper: {
    paddingLeft: '5px'
  }
}));

export interface IPropsText {
  label?: string;
  description?: string;
  tooltip?: string;
  isHideDescription?: boolean;
}

type IProps = IPropsText & typeof MtsFormGroup.defaultProps;

const FormGroup: FC<IProps> = ({
  children,
  label,
  tooltip,
  description,
  isHideDescription,
  ...props
}) => {
  const classes = useStyles();
  const childElement = React.Children.toArray(children).find(
    (c): c is React.ReactElement => React.isValidElement(c)
  );
  const inputId = (childElement?.props?.id || childElement?.props?.name) as string | undefined;
  return (
    <MtsFormGroup className={classes.group} {...props}>
      {label && (
        <label className={classes.root} {...(inputId ? { htmlFor: inputId } : {})}>
          {label}
          {tooltip && (
            <Tooltip label={tooltip}>
              <Grid item xs container className={classes.wrapper}>
                <Icon name="info" size="s" color="icon-tertiary" />
              </Grid>
            </Tooltip>
          )}
        </label>
      )}
      {children}

      {!isHideDescription && (
        <MtsFormGroup slot="bottom">
          <MtsLabel>{description}</MtsLabel>
        </MtsFormGroup>
      )}
    </MtsFormGroup>
  );
};

export default FormGroup;
